import React from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { MyPlayLoader } from "@myplay/ui";

import "./SceneLoaderWrapper.scss";

const SceneLoaderWrapper = ({ MetaStore, children }) => {
  const { isLoading } = MetaStore;
  return isLoading ?
    <div className="scene-loader-wrapper">
      <MyPlayLoader color="#fff" />
    </div> : children
};

SceneLoaderWrapper.propTypes = {
  MetaStore: PropTypes.object,
  children: PropTypes.any
};

SceneLoaderWrapper.defaultProps = {
  MetaStore: { isLoading: true },
  children: null
};

export default inject("MetaStore")(observer(SceneLoaderWrapper));